import React, { useEffect } from 'react';
import { useInputHelper, DefaultInputPropTypes } from 'framework/form';
import CardDocumentInput from './CardDocumentInput';

interface CardIdentityDocumentInputProps extends DefaultInputPropTypes<any> {
  onRemove?: () => void;
  showRemove?: boolean;
  onChangeCallback?: (value: any) => void;
}

const CardIdentityDocumentInput = (props: CardIdentityDocumentInputProps) => {
  const { onRemove, showRemove, onChangeCallback } = props;
  const { getSource, getRawOnChangeCallback, getValue } = useInputHelper(props);

  const identityDocument = getValue() || {};
  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});
  const source = getSource();

  useEffect(() => {
    const currentValue = getValue();
    if (!currentValue) {
      const initialValue = { [source]: {} };
      rawOnChangeCallback(initialValue);
      onChangeCallback?.(initialValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (value: any) => {
    rawOnChangeCallback(value);
    if (onChangeCallback) {
      onChangeCallback(value);
    }
  };

  return (
    <CardDocumentInput
      value={identityDocument}
      source={source}
      onRemove={onRemove}
      showRemove={showRemove}
      onChange={handleChange}
    />
  );
};

export default CardIdentityDocumentInput;
